import { render, staticRenderFns } from "./phoneExtDepartmentSortable.vue?vue&type=template&id=41bf0af8&scoped=true&"
import script from "./phoneExtDepartmentSortable.vue?vue&type=script&lang=js&"
export * from "./phoneExtDepartmentSortable.vue?vue&type=script&lang=js&"
import style0 from "./phoneExtDepartmentSortable.vue?vue&type=style&index=0&id=41bf0af8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bf0af8",
  null
  
)

export default component.exports